var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IntlProvider } from 'react-intl';
import useLocaleData from '../hooks/useLocaleData';
var LocaleProvider = function (_a) {
    var _b = _a.defaultLocale, defaultLocale = _b === void 0 ? 'en' : _b, locale = _a.locale, children = _a.children, props = __rest(_a, ["defaultLocale", "locale", "children"]);
    var _c = useLocaleData(defaultLocale, locale), messages = _c.data, selectedLocale = _c.locale;
    return (_jsx(IntlProvider, __assign({ messages: messages, locale: selectedLocale, defaultLocale: defaultLocale }, props, { children: children })));
};
export default LocaleProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9jYWxlUHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Mb2NhbGVQcm92aWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFDQSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBRTFDLE9BQU8sYUFBYSxNQUFNLHdCQUF3QixDQUFDO0FBTW5ELElBQU0sY0FBYyxHQUFHLFVBQUMsRUFLRjtJQUpwQixJQUFBLHFCQUFvQixFQUFwQixhQUFhLG1CQUFHLElBQUksS0FBQSxFQUNwQixNQUFNLFlBQUEsRUFDTixRQUFRLGNBQUEsRUFDTCxLQUFLLGNBSmMsdUNBS3ZCLENBRFM7SUFFRixJQUFBLEtBQTZDLGFBQWEsQ0FDOUQsYUFBYSxFQUNiLE1BQU0sQ0FDUCxFQUhhLFFBQVEsVUFBQSxFQUFVLGNBQWMsWUFHN0MsQ0FBQztJQUVGLE9BQU8sQ0FDTCxLQUFDLFlBQVksYUFDWCxRQUFRLEVBQUUsUUFBUSxFQUNsQixNQUFNLEVBQUUsY0FBYyxFQUN0QixhQUFhLEVBQUUsYUFBYSxJQUN4QixLQUFLLGNBRVIsUUFBUSxJQUNJLENBQ2hCLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLGNBQWMsQ0FBQyJ9